<template>
  <div class="multi-input">
    <div class="tags" @click="focusInput">
      <span
        v-for="(tag, index) in tags"
        :key="index"
        class="tag"
      >
        {{ tag }}
        <button type="button" class="remove" @click.stop="removeTag(index)">×</button>
      </span>

      <input
        ref="input"
        type="text"
        v-model="inputValue"
        @keydown.enter.prevent="addTag"
        @blur="addTag"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "MultiTagInput",

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      tags: [...this.value],
      inputValue: ""
    };
  },

  watch: {
    value(newVal) {
      this.tags = [...newVal];
    }
  },

  methods: {
    addTag() {
      const val = this.inputValue.trim();
      if (!val) return;

      this.tags.push(val);
      this.inputValue = "";
      this.emitUpdate();
    },

    removeTag(index) {
      this.tags.splice(index, 1);
      this.emitUpdate();
    },

    emitUpdate() {
      this.$emit("update", this.tags);
    },

    focusInput() {
      this.$refs.input.focus();
    }
  }
};
</script>

<style scoped>
.multi-input {
  width: 100%;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  width: 100%;
  padding: 6px 8px;

  border: 1px solid #BCBCBC;
  border-radius: 4px;
  cursor: text;
}

.tag {
  display: flex;
  align-items: center;
  background: #f1f1f1;
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 14px;
}

.remove {
  border: none;
  background: transparent;
  font-size: 16px;
  margin-left: 6px;
  cursor: pointer;
  opacity: 0.7;
}

.remove:hover {
  opacity: 1;
}

.tags input {
  border: none;
  outline: none;
  font-size: 14px;
  padding: 4px;
  min-width: 100px;
  flex: 1;
}
</style>
